import { render, staticRenderFns } from "./sidebaradvance.vue?vue&type=template&id=b52611aa"
import script from "./sidebaradvance.vue?vue&type=script&lang=js"
export * from "./sidebaradvance.vue?vue&type=script&lang=js"
import style0 from "./sidebaradvance.vue?vue&type=style&index=0&id=b52611aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports